// Bundle theme module
import NSTheme from "./NSTheme";
import Helper from "./Classes/Helper";
// import setYoutubeLinks from "./Classes/setYoutubeLinks";
// import Gri from "./Classes/Gri";
import AnchorPDF from "./Classes/AnchorPDF";
// import PDFFootOrHead from "./Classes/PDFFootOrHead";

export default NSTheme;

(function() {
  document.addEventListener("DOMContentLoaded", () => {

    // if (document.documentElement.lang == "de") {
    //   new PDFFootOrHead({
    //     cssClass: 'page-header',
    //     elementInnerHTML: '<span>Alpiq Gesch&auml;ftsbericht 2020</span>'
    //   });
    // } else {
    //   new PDFFootOrHead({
    //     cssClass: 'page-header',
    //     elementInnerHTML: '<span>Alpiq Annual Report 2020</span>'
    //   });
    // }

    new AnchorPDF({
      anchorSelector: '.ns-anchor'
    });

    // new setYoutubeLinks({
    //   videoContainerSelector: ".ns-video"
    // });

    // new Gri();

  });
})();
